import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { isSameMinute } from "date-fns";

@Component({
  selector: "display-accordion-requests",
  templateUrl: "./display-accordion-requests.component.html",
  styleUrls: ["./display-accordion-requests.component.scss"]
})
export class DisplayAccordionRequestsComponent implements OnInit {
  @Input() requestsResults;
  @Output() editRequest = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() sendMessage = new EventEmitter();
  @Output() openRequest = new EventEmitter();
  @Output() openRequestValidated = new EventEmitter();
  @Input() isMine;
  @Input() showDocumentDebrief: boolean = false;
  @Output() seeDocument = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  onEdit(request, i) {
    this.editRequest.emit({ request, i });
  }
  onopenRequest(request, i) {
    this.openRequest.emit({ request, i });
  }
  onseeDocument(document, request) {
    this.seeDocument.emit({ document, request });
  }
  onDelete(request, i) {
    this.delete.emit({ id: request._id, i });
  }

  onSendMessage(request, i) {
    this.sendMessage.emit({ request, i });
  }

  onClickSeeRequestValidated(event, request, i) {
    event.stopPropagation();
    this.openRequestValidated.emit({ request, i });
  }
  actions($event, request, i) {
    if ($event == "editRequest") {
      this.onEdit(request, i);
    } else if ($event == "sendMessage") {
      this.onSendMessage(request, i);
    } else if ($event == "changeStatus") {
      this.openRequestValidated.emit({ request, i });
    }else if($event =='delete'){
      this.onDelete(request, i);
    }
  }
}
